import { useState } from "react";
import { apiRequest } from "@/lib/queryClient";

interface UploadFileResponse {
  objectPath: string;
}

interface UploadResult {
  objectPath: string;
}

export function useUpload() {
  const [isUploading, setIsUploading] = useState(false);

  async function uploadFile(
    file: File,
    options?: { contentType?: string },
  ): Promise<UploadResult | null> {
    setIsUploading(true);
    try {
      const contentType = options?.contentType ?? file.type;

      const base64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result as string;
          // Strip the "data:<mime>;base64," prefix
          resolve(result.split(",")[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      const res = await apiRequest("POST", "/api/uploads/file", {
        file: base64,
        contentType,
      });
      const { objectPath } = (await res.json()) as UploadFileResponse;

      return { objectPath };
    } catch {
      return null;
    } finally {
      setIsUploading(false);
    }
  }

  return { uploadFile, isUploading };
}
